import { BrowserRouter, Navigate, Routes, Route, Outlet } from 'react-router-dom';
import { useAuth } from './store';
import { isShareDeviceOnly } from './constants';
import { LoginPage } from './pages/Login.page';
import { DashboardPage } from './pages/Dashboard.page';
import { AdminTablePage } from './pages/AdminTable.page';
import { StaffTablePage } from './pages/StaffTable.page';
import { TransactionsPage } from './pages/Transactions.page';
import { NotifyListener } from './components/NotifyModal/NotifyListener';

// Blocks routes a shared device must not reach, including by typing the URL.
// Hiding the nav link alone would not stop that.
function ShareDeviceOnlyGuard() {
  const { user } = useAuth();
  if (isShareDeviceOnly(user)) return <Navigate to="/dashboard" replace />;
  return <Outlet />;
}

// Routes that require an authenticated user; otherwise redirect to login.
// The NotifyListener polls for incoming notifications on every protected page.
function ProtectedRoute() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return (
    <>
      <NotifyListener />
      <Outlet />
    </>
  );
}

export function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          {/* Any logged-in user except a shared device can view the staff list;
              only admins see the add-staff form (gated inside the page). */}
          <Route element={<ShareDeviceOnlyGuard />}>
            <Route path="/admin" element={<AdminTablePage />} />
            <Route path="/staff" element={<StaffTablePage />} />
            <Route path="/transaction" element={<TransactionsPage />} />
          </Route>
        </Route>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
